<div class="bubble-chart-wrapper">
    <div #bubbleChart></div>
</div>
